<template>
  <el-row class="privilege-container">
    <el-col :span="16">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <span>权限组</span>
          <el-button
            type="primary"
            size="small"
            class="float-right"
            @click="openAddPrivilegeGroup"
          >
            <i class="el-icon-plus"></i>添加
          </el-button>
        </div>
        <el-table
          :data="privilegeInfo.privilegeGroups"
          style="width: 100%"
          border
        >
          <el-table-column prop="name" label="名称" align="center">
            <template slot-scope="scope">
              <span class="link-type" @click="notifyQueryPrivilege(scope.row)">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="pgId" label="编码" align="center">
            <template slot-scope="scope">
              <span class="link-type" @click="notifyQueryPrivilege(scope.row)">
                {{ scope.row.pgId }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="权限组描述" align="center" />
          <el-table-column prop="createTime" label="创建时间" align="center" />
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.storeId != '9999'"
                size="mini"
                @click="openEditPrivilegeGroup(scope.row)"
              >修改</el-button>
              <el-button
                v-if="scope.row.storeId != '9999'"
                size="mini"
                type="danger"
                @click="openDeletePrivilegeGroup(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          layout="prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </el-card>
    </el-col>

    <el-col :span="8" class="animated fadeInRight">
      <el-card class="box-card">
        <div slot="header" class="flex justify-between">
          <h2>{{ privilegeInfo._currentPgName }}-权限</h2>
        </div>
        <div class="mail-box">
          <el-tree
            :data="treeData"
            show-checkbox
            node-key="id"
            :props="defaultProps"
            @check="handleCheckChange"
          />
        </div>
      </el-card>
    </el-col>

    <add-privilege-group ref="addPrivilegeGroup" @refresh="loadPrivilegeGroup" />
    <edit-privilege-group ref="editPrivilegeGroup" @refresh="loadPrivilegeGroup" />
    <delete-privilege-group ref="deletePrivilegeGroup" @refresh="loadPrivilegeGroup" />
  </el-row>
</template>

<script>
import { getPrivilegeGroupList, getPrivilegeList } from '@/api/frame/privilegeGroupApi'
import AddPrivilegeGroup from '@/components/frame/addPrivilegeGroup/addPrivilegeGroup.vue'
import EditPrivilegeGroup from '@/components/frame/editPrivilegeGroup/editPrivilegeGroup.vue'
import DeletePrivilegeGroup from '@/components/frame/deletePrivilegeGroup/deletePrivilegeGroup.vue'

export default {
  name: 'Privilege',
  components: {
    AddPrivilegeGroup,
    EditPrivilegeGroup,
    DeletePrivilegeGroup
  },
  data() {
    return {
      privilegeInfo: {
        _currentPgId: '',
        _currentPgName: '',
        _pName: '',
        _currentStoreId: '9999',
        _privileges: [],
        privilegeGroups: []
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      total: 0,
      currentPage: 1
    }
  },
  created() {
    this.loadPrivilegeGroup()
  },
  methods: {
    async loadPrivilegeGroup() {
      try {
        const res = await getPrivilegeGroupList({
          page: this.currentPage
        })
        this.privilegeInfo.privilegeGroups = res.data
        this.total = res.total
        if (res.data.length > 0) {
          this.notifyQueryPrivilege(res.data[0])
        }
      } catch (error) {
        console.error('获取权限组失败:', error)
      }
    },
    async notifyQueryPrivilege(pGroup) {
      this.privilegeInfo._currentPgId = pGroup.pgId
      this.privilegeInfo._currentPgName = pGroup.name
      this.privilegeInfo._currentStoreId = pGroup.storeId
      await this.loadPrivilege(pGroup.pgId)
    },
    async loadPrivilege(pgId) {
      try {
        const res = await getPrivilegeList({
          pgId,
          name: this.privilegeInfo._pName
        })
        this.privilegeInfo._privileges = res.data
        this.initTreeData(res.data)
      } catch (error) {
        console.error('获取权限失败:', error)
      }
    },
    initTreeData(privileges) {
      console.log(privileges)
      // 实现树形数据处理逻辑
      // ...
    },
    handleCheckChange(data, checked) {
      console.log(data,checked)
      // 处理树节点选中变化
      // ...
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.loadPrivilegeGroup()
    },
    openAddPrivilegeGroup() {
      this.$refs.addPrivilegeGroup.open()
    },
    openEditPrivilegeGroup(row) {
      this.$refs.editPrivilegeGroup.open(row)
    },
    openDeletePrivilegeGroup(row) {
      this.$refs.deletePrivilegeGroup.open(row)
    }
  }
}
</script>

<style scoped>
.privilege-container {
  width: 100%;
}
.link-type {
  color: #409EFF;
  cursor: pointer;
}
.pagination {
  margin-top: 15px;
  text-align: right;
}
.float-right {
  float: right;
}
</style>